export const searchConstants = {
  RUN_REQUEST: 'SEARCH_RUN_REQUEST',
  RUN_SUCCESS: 'SEARCH_RUN_SUCCESS',
  RUN_FAILURE: 'SEARCH_RUN_FAILURE',
  CLEAR: 'SEARCH_CLEAR',
  SET_KINDS: 'SEARCH_SET_KINDS',
};

export const initialSearchState = {
  q: '', kinds: [], seq: 0, ids: [], byId: {}, total: 0, status: 'idle', error: null,
};
